'use client';
import * as React from 'react';
import { useCarouselViewport_unstable } from './useCarouselViewport';
import { renderCarouselViewport_unstable } from './renderCarouselViewport';
import { useCarouselViewportStyles_unstable } from './useCarouselViewportStyles.styles';
import { useCarouselSliderContextValues_unstable } from '../CarouselSlider/CarouselSliderContext';
import { useCustomStyleHook_unstable } from '@fluentui/react-shared-contexts';
/**
 * CarouselViewport component - TODO: add more docs
 */ export const CarouselViewport = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useCarouselViewport_unstable(props, ref);
    useCarouselViewportStyles_unstable(state);
    useCustomStyleHook_unstable('useCarouselViewportStyles_unstable')(state);
    const context = useCarouselSliderContextValues_unstable(state);
    return renderCarouselViewport_unstable(state, context);
});
CarouselViewport.displayName = 'CarouselViewport';
